/* Coverly Samples — filtering, selection and a single batched add to cart.

   Tiles either arrive server-rendered (fallback path) or are built from a
   catalogue JSON. Either way they end up as the same DOM with the same data
   attributes, so everything below works against one shape. */
(function () {
  // Fallback only. The section normally supplies the palette as blocks so it is
  // editable in the theme editor; this is what a section with no colour blocks
  // configured falls back to.
  var DEFAULT_FAMILIES = [
    ['White', '#FFFFFF'], ['Cream', '#F3EAD8'], ['Beige', '#D9C7AC'],
    ['Gray', '#9A9A9A'], ['Charcoal', '#4A4A4A'], ['Black', '#151515'],
    ['Brown', '#6B4B32'], ['Tan', '#C29A6C'], ['Blue', '#4A6D9B'],
    ['Green', '#5C7A5C'], ['Warm', '#B45B3E'],
    ['Pink', '#D9A0A8'], ['Purple', '#7A6291']
  ];

  var ZOOM_ICON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true">' +
    '<circle cx="11" cy="11" r="7" /><path d="M20 20l-3.5-3.5" stroke-linecap="round" /></svg>';

  // Tiles are served at 600px for the grid. The close-up wants the biggest
  // render the CDN will give us, so bump the width parameter rather than
  // shipping a second, larger <img> in every tile.
  function bigSrc(img) {
    if (!img) return '';
    var src = img.currentSrc || img.src || '';
    if (!src) return '';
    return /([?&])width=\d+/.test(src)
      ? src.replace(/([?&])width=\d+/, '$1width=1600')
      : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1600';
  }

  function init(root) {
    if (root.dataset.csInit === 'true') return;
    root.dataset.csInit = 'true';

    var grid = root.querySelector('[data-cs-grid]');
    var bar = root.querySelector('[data-cs-bar]');
    var summary = root.querySelector('[data-cs-summary]');
    var countEl = root.querySelector('[data-cs-count]');
    var emptyEl = root.querySelector('[data-cs-empty]');
    var clearBtn = root.querySelector('[data-cs-clear]');
    var searchEl = root.querySelector('[data-cs-search]');
    var typesEl = root.querySelector('[data-cs-types]');
    var colorsEl = root.querySelector('[data-cs-colors]');
    var cap = parseInt(root.dataset.cap, 10) || 15;

    // Palette authored in the theme editor, in the order the blocks are arranged.
    var FAMILIES = DEFAULT_FAMILIES;
    var paletteEl = root.querySelector('[data-cs-palette]');
    if (paletteEl) {
      try {
        var authored = JSON.parse(paletteEl.textContent);
        if (authored.length) {
          FAMILIES = authored
            .filter(function (p) { return p.name; })
            .map(function (p) { return [p.name, p.hex || '#CCCCCC']; });
        }
      } catch (e) { /* malformed palette: keep the defaults rather than no dots */ }
    }
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';

    var selected = new Map();
    var filters = { type: '', color: '', opacity: '', texture: '', q: '' };

    function money(cents) {
      var amount = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    }

    /* ---------- catalogue ---------- */

    function tileFromRecord(r) {
      var el = document.createElement('button');
      el.type = 'button';
      el.className = 'cs__tile';
      el.setAttribute('aria-pressed', 'false');
      el.setAttribute('data-cs-tile', '');
      el.dataset.id = r.id;
      el.dataset.variant = r.variant_id;
      el.dataset.handle = r.product_handle || '';
      el.dataset.line = r.fabric_line || '';
      el.dataset.colorway = r.colorway || '';
      el.dataset.color = r.color_family || '';
      el.dataset.opacity = r.opacity || '';
      el.dataset.texture = r.texture || '';
      el.dataset.price = r.price == null ? '' : r.price;
      el.dataset.types = (r.types || []).join(',');
      el.dataset.parents = (r.parent_handles || []).join(',');
      el.dataset.weight = r.sort_weight || 0;
      el.dataset.available = 'true';

      // Alt text follows the image SEO template rather than the bare title.
      var alt = [r.colorway, r.fabric_line, r.opacity, (r.types || [])[0], 'shade fabric sample']
        .filter(Boolean).join(' ');
      el.innerHTML =
        '<span class="cs__tile-img">' +
          (r.img ? '<img src="' + r.img + '" loading="lazy" alt="' + alt.replace(/"/g, '&quot;') + '">' : '') +
          '<span class="cs__tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 13l4 4L19 7" stroke-linecap="round" stroke-linejoin="round"/></svg></span>' +
        '</span>' +
        '<span class="cs__tile-line"></span>' +
        (r.colorway ? '<span class="cs__tile-way"></span>' : '') +
        (r.opacity ? '<span class="cs__tile-op"></span>' : '') +
        '<span class="cs__tile-price"></span>';
      el.querySelector('.cs__tile-line').textContent = r.fabric_line || '';
      if (r.colorway) el.querySelector('.cs__tile-way').textContent = r.colorway;
      if (r.opacity) el.querySelector('.cs__tile-op').textContent = r.opacity;
      el.querySelector('.cs__tile-price').textContent = r.price == null ? '' : money(r.price);

      // Same shape the Liquid renders: the zoom control is a sibling of the
      // tile, because the tile is itself a button.
      var cell = document.createElement('div');
      cell.className = 'cs__cell';
      cell.setAttribute('role', 'listitem');
      cell.appendChild(el);
      var z = document.createElement('button');
      z.type = 'button';
      z.className = 'cs__zoom';
      z.tabIndex = -1;
      z.setAttribute('data-cs-zoom', '');
      z.setAttribute('aria-label', 'Enlarge ' + (r.colorway || r.fabric_line || 'sample'));
      z.innerHTML = ZOOM_ICON;
      cell.appendChild(z);
      return cell;
    }

    function loadCatalog() {
      var url = root.dataset.catalog;
      if (!url) return Promise.resolve(false);
      return fetch(url, { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (data) {
          // Filtered before the length check, so a catalogue that happens to
          // be entirely out of stock falls back to the server-rendered grid
          // rather than emptying it.
          var list = ((data && data.swatches) || []).filter(function (r) {
            return r.available !== false;
          });
          if (!list.length) return false;
          var frag = document.createDocumentFragment();
          list.forEach(function (r) { frag.appendChild(tileFromRecord(r)); });
          grid.textContent = '';
          grid.appendChild(frag);
          return true;
        })
        // The server-rendered grid is already in the DOM, so a failure here
        // degrades to a smaller catalogue rather than an empty page.
        .catch(function () { return false; });
    }

    /* ---------- grouping ---------- */

    function tiles() { return Array.prototype.slice.call(grid.querySelectorAll('[data-cs-tile]')); }

    // Layout and visibility act on the cell; everything else still reads the
    // tile, which is where all the data- attributes live.
    function cellOf(t) { return t.closest('.cs__cell') || t; }

    // One grid per type so two categories can never share a row: a group is a
    // separate grid container, and a grid always starts its own row. Grouping
    // by the whole type SET rather than a single type keeps a swatch in exactly
    // one place — a Roller+Roman fabric belongs under "Roller / Roman", not
    // duplicated into two groups where selecting it twice would be possible.
    function weightOf(t) { return parseInt(t.dataset.weight, 10) || 0; }

    function buildGroups() {
      var order = [], byKey = {}, seenAt = {};
      tiles().forEach(function (t, i) {
        var key = t.dataset.types || '';
        if (!byKey[key]) { byKey[key] = []; order.push(key); seenAt[key] = i; }
        byKey[key].push({ el: t, w: weightOf(t), i: i });
      });

      // sort_weight descending, highest first, so raising a number promotes it.
      // Ties fall back to the order the catalogue delivered them in, which
      // keeps the arrangement stable instead of reshuffling on every load.
      order.sort(function (a, b) {
        var wa = Math.max.apply(null, byKey[a].map(function (x) { return x.w; }));
        var wb = Math.max.apply(null, byKey[b].map(function (x) { return x.w; }));
        return wb - wa || seenAt[a] - seenAt[b];
      });
      Object.keys(byKey).forEach(function (k) {
        byKey[k].sort(function (a, b) { return b.w - a.w || a.i - b.i; });
      });

      grid.textContent = '';
      grid.removeAttribute('role');
      order.forEach(function (key) {
        var group = document.createElement('div');
        group.className = 'cs__group';
        group.setAttribute('data-cs-group', key);

        if (key) {
          var h = document.createElement('h2');
          h.className = 'cs__group-title';
          h.textContent = key.split(',').join(' / ');
          group.appendChild(h);
        }

        var items = document.createElement('div');
        items.className = 'cs__group-items';
        items.setAttribute('role', 'list');
        byKey[key].forEach(function (x) { items.appendChild(cellOf(x.el)); });
        group.appendChild(items);
        grid.appendChild(group);
      });
    }

    /* ---------- facets built from the data actually present ---------- */

    function buildFacets() {
      var all = tiles();
      var types = new Set(), colors = new Set(), ops = new Set(), texs = new Set();
      all.forEach(function (t) {
        (t.dataset.types || '').split(',').forEach(function (v) { if (v) types.add(v); });
        if (t.dataset.color) colors.add(t.dataset.color);
        if (t.dataset.opacity) ops.add(t.dataset.opacity);
        if (t.dataset.texture) texs.add(t.dataset.texture);
      });

      typesEl.textContent = '';
      if (types.size) {
        typesEl.appendChild(typeChip('', 'All'));
        Array.from(types).sort().forEach(function (v) { typesEl.appendChild(typeChip(v, v)); });
      }

      function addDot(name, hex) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'cs__dot';
        b.style.setProperty('--dot', hex);
        b.setAttribute('aria-label', name);
        b.setAttribute('aria-pressed', 'false');
        b.dataset.color = name;
        b.addEventListener('click', function () {
          filters.color = filters.color === name ? '' : name;
          syncControls(); apply();
        });
        colorsEl.appendChild(b);
      }

      colorsEl.textContent = '';
      var configured = {};
      FAMILIES.forEach(function (pair) {
        configured[pair[0]] = true;
        if (colors.has(pair[0])) addDot(pair[0], pair[1]);
      });
      // A family in the data that nobody gave a dot to would otherwise be
      // silently unfilterable. Grey is a prompt to go and configure it.
      Array.from(colors).sort().forEach(function (name) {
        if (!configured[name]) addDot(name, '#CCCCCC');
      });

      fillSelect('opacity', ops);
      fillSelect('texture', texs);
    }

    function typeChip(value, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cs__chip';
      b.textContent = label;
      b.dataset.type = value;
      b.setAttribute('aria-pressed', String(filters.type === value));
      b.addEventListener('click', function () {
        filters.type = value;
        writeUrl();
        syncControls(); apply();
      });
      return b;
    }

    function fillSelect(name, values) {
      var sel = root.querySelector('[data-cs-filter="' + name + '"]');
      if (!sel) return;
      var current = sel.value;
      sel.textContent = '';
      var any = document.createElement('option');
      any.value = ''; any.textContent = 'Any';
      sel.appendChild(any);
      Array.from(values).sort().forEach(function (v) {
        var o = document.createElement('option');
        o.value = v; o.textContent = v;
        sel.appendChild(o);
      });
      sel.value = current;
      var wrap = sel.closest('.cs__field');
      if (wrap) wrap.hidden = values.size === 0;
    }

    /* ---------- filtering ---------- */

    function matches(t) {
      if (filters.type && (t.dataset.types || '').split(',').indexOf(filters.type) === -1) return false;
      if (filters.color && t.dataset.color !== filters.color) return false;
      if (filters.opacity && t.dataset.opacity !== filters.opacity) return false;
      if (filters.texture && t.dataset.texture !== filters.texture) return false;
      if (filters.q) {
        var hay = (t.dataset.line + ' ' + t.dataset.colorway).toLowerCase();
        if (hay.indexOf(filters.q) === -1) return false;
      }
      return true;
    }

    function activeCount() {
      return ['type', 'color', 'opacity', 'texture', 'q'].filter(function (k) { return filters[k]; }).length;
    }

    function apply() {
      var shown = 0;
      tiles().forEach(function (t) {
        var ok = matches(t);
        cellOf(t).hidden = !ok;
        if (ok) shown++;
      });
      grid.querySelectorAll('.cs__group').forEach(function (g) {
        g.hidden = !g.querySelector('.cs__cell:not([hidden]) [data-cs-tile]');
      });

      countEl.textContent = shown + (shown === 1 ? ' swatch' : ' swatches');
      clearBtn.hidden = activeCount() === 0;

      if (shown === 0) {
        // Name the culprit rather than saying "no results".
        var culprit = filters.opacity ? ['opacity', filters.opacity]
          : filters.texture ? ['texture', filters.texture]
          : filters.color ? ['colour', filters.color]
          : filters.q ? ['search', filters.q] : null;
        emptyEl.textContent = culprit
          ? 'Nothing matches that combination. Try clearing ' + culprit[0] + ' — ' + culprit[1] + '.'
          : 'No samples available yet.';
        emptyEl.hidden = false;
      } else {
        emptyEl.hidden = true;
      }
    }

    function syncControls() {
      typesEl.querySelectorAll('.cs__chip').forEach(function (c) {
        c.setAttribute('aria-pressed', String(c.dataset.type === filters.type));
      });
      colorsEl.querySelectorAll('.cs__dot').forEach(function (d) {
        d.setAttribute('aria-pressed', String(d.dataset.color === filters.color));
      });
    }

    /* ---------- url state ---------- */

    function readUrl() {
      var p = new URLSearchParams(window.location.search);
      filters.type = p.get('type') || '';
    }

    function writeUrl() {
      var url = new URL(window.location.href);
      if (filters.type) url.searchParams.set('type', filters.type);
      else url.searchParams.delete('type');
      history.pushState({}, '', url);
    }

    /* ---------- selection ---------- */

    function toggle(tile) {
      var id = tile.dataset.id;
      if (selected.has(id)) {
        selected.delete(id);
      } else {
        if (selected.size >= cap) {
          summary.textContent = 'That is the maximum of ' + cap + ' swatches per order.';
          return;
        }
        selected.set(id, tile);
      }
      tile.setAttribute('aria-pressed', String(selected.has(id)));
      tile.classList.toggle('is-selected', selected.has(id));
      renderBar();
    }

    function renderBar() {
      var n = selected.size;
      bar.hidden = n === 0;
      if (!n) return;
      var total = 0;
      selected.forEach(function (t) { total += parseInt(t.dataset.price, 10) || 0; });
      summary.textContent = n + (n === 1 ? ' swatch' : ' swatches') + ' · ' + money(total);
    }

    grid.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      // Checked first: the zoom button sits over the tile, and a click on it
      // must never also flip the selection underneath.
      var zoom = e.target.closest('[data-cs-zoom]');
      if (zoom) {
        var zt = zoom.parentNode.querySelector('[data-cs-tile]');
        if (zt) openZoom(zt);
        return;
      }
      var tile = e.target.closest('[data-cs-tile]');
      if (tile && !tile.disabled) toggle(tile);
    });

    /* ---------- close-up ---------- */

    var zoomer = root.querySelector('[data-cs-zoomer]');
    var zImg = root.querySelector('[data-cs-zoomer-img]');
    var zWay = root.querySelector('[data-cs-zoomer-way]');
    var zLine = root.querySelector('[data-cs-zoomer-line]');
    var zSub = root.querySelector('[data-cs-zoomer-sub]');
    var zAdd = root.querySelector('[data-cs-zoomer-add]');
    var zClose = root.querySelector('[data-cs-zoomer-close]');
    var zTile = null;

    function zSyncAdd() {
      if (!zTile) return;
      var on = selected.has(zTile.dataset.id);
      zAdd.textContent = on ? 'Remove from order' : 'Add to order';
      zAdd.setAttribute('aria-pressed', String(on));
      zAdd.disabled = zTile.disabled;
    }

    function openZoom(tile) {
      if (!zoomer || !zoomer.showModal) return;
      zTile = tile;
      var img = tile.querySelector('img');
      zImg.src = bigSrc(img);
      zImg.alt = img ? img.alt : '';
      zWay.textContent = tile.dataset.colorway || '';
      zLine.textContent = tile.dataset.line || '';
      zSub.textContent = [tile.dataset.opacity, tile.dataset.texture]
        .filter(Boolean).join(' · ');
      zSub.hidden = !zSub.textContent;
      zSyncAdd();
      zoomer.showModal();
    }

    // Releasing the 1600px render is tied to the explicit close paths rather
    // than to the dialog's own close event alone, so it still happens in
    // engines that are stingy about firing it.
    function releaseZoom() {
      zImg.removeAttribute('src');
      zTile = null;
    }

    function closeZoom() {
      zoomer.close();
      releaseZoom();
    }

    if (zoomer) {
      zClose.addEventListener('click', closeZoom);
      zAdd.addEventListener('click', function () {
        if (zTile && !zTile.disabled) { toggle(zTile); zSyncAdd(); }
      });
      // A <dialog> fills its own box; the area around it is the backdrop, so a
      // click landing on the dialog element itself is a click outside the card.
      zoomer.addEventListener('click', function (e) {
        if (e.target === zoomer) closeZoom();
      });
      // The dialog closes itself on Escape. Doing it explicitly too costs
      // nothing when the browser already has, and covers environments that
      // deliver the keypress without a key code, which skips the native path.
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && zoomer.open) { e.preventDefault(); closeZoom(); }
      });
      // Covers the browser closing the dialog on Escape without us.
      zoomer.addEventListener('close', releaseZoom);
    }

    /* ---------- add to cart ---------- */

    root.querySelector('[data-cs-deselect]').addEventListener('click', function () {
      selected.forEach(function (t) {
        t.setAttribute('aria-pressed', 'false');
        t.classList.remove('is-selected');
      });
      selected.clear();
      renderBar();
    });

    var goBtn = root.querySelector('[data-cs-continue]');
    var goLabel = root.querySelector('[data-cs-continue-label]');
    goBtn.addEventListener('click', function () {
      if (!selected.size || goBtn.disabled) return;
      // One request for the whole selection. Clicking through a product page
      // per swatch is what drives average selection down to two or three.
      var items = [];
      selected.forEach(function (t) {
        items.push({
          id: parseInt(t.dataset.variant, 10),
          quantity: 1,
          properties: {
            _swatch: 'true',
            _fabric_id: t.dataset.id,
            _parent_handles: t.dataset.parents || '',
            _source: 'samples_page'
          }
        });
      });
      goBtn.disabled = true;
      goLabel.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('coverly:samples:added', { detail: { count: items.length } }));
          window.location.href = '/cart';
        })
        .catch(function () {
          goBtn.disabled = false;
          goLabel.textContent = 'Add to cart';
          summary.textContent = 'Could not add those samples. Please try again.';
        });
    });

    /* ---------- wiring ---------- */

    root.querySelectorAll('[data-cs-filter]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        filters[sel.dataset.csFilter] = sel.value;
        apply();
      });
    });

    if (searchEl) {
      var t;
      searchEl.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { filters.q = searchEl.value.trim().toLowerCase(); apply(); }, 150);
      });
    }

    clearBtn.addEventListener('click', function () {
      filters = { type: '', color: '', opacity: '', texture: '', q: '' };
      if (searchEl) searchEl.value = '';
      root.querySelectorAll('[data-cs-filter]').forEach(function (s) { s.value = ''; });
      writeUrl(); syncControls(); apply();
    });

    window.addEventListener('popstate', function () { readUrl(); syncControls(); apply(); });

    readUrl();
    loadCatalog().then(function () {
      buildGroups();
      buildFacets();
      syncControls();
      apply();
    });
  }

  function initAll() { document.querySelectorAll('[data-cs-root]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
